module.exports = {
          srcSet: __webpack_public_path__ + "9805bbce.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "9805bbce.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "9805bbce.jpg",
          toString:function(){return __webpack_public_path__ + "9805bbce.jpg"},
          
          width: 330,
          height: 200
        }